/**
 * Constants : API
 * ---
 * File that reads the API's configurations.
 */

const configs =
    process.env.NODE_ENV === 'development' ? (window.Configs || {}).development || {} : {}

// Staging/production: API is served from the same host as the app
export const API_URL = configs.API || window.location.origin
